export default {
  // 认证相关配置
  authTokenName: 'token',
  
  // API相关配置
  apiTimeout: 15000,
  
  // 其他配置
  siteName: '欧那官网'
}
